import React, { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import LoadingSpinner from './LoadingSpinner';
import Header from './Header';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { setLoading, signUpSuccess } from '../../features/authSlice';
import { getDcpIndexScore, getMeUser, getStudentData, getUser } from '../../api/authApi';
import { showNotification } from './Notification/ToastifyNotification';
import { UserTypeId } from '../const';

const PrivateRoute = ({ children }) => {
  const { loading } = useSelector((state) => state.auth);
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const tokenFromUrl = searchParams.get('accessToken');
  if (tokenFromUrl) {
    // Store token
    localStorage.setItem('token', tokenFromUrl);

    // Clean URL immediately
    searchParams.delete('accessToken');
    const newUrl = location.pathname +
      (searchParams.toString() ? `?${searchParams.toString()}` : '');

    // Replace URL without navigation
    window.history.replaceState({}, '', newUrl);
  }
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const getUserData = async () => {
    try {
      const response = await getMeUser();
      if (response?.data?.user_type_id === UserTypeId.Mentor) {
        navigate('/mentor-dashboard');
      } else if (response?.data?.user_type_id === UserTypeId.Admin) {
        navigate('/admin-dashboard')
      } else {
        if (response.data?.user_id) {
          const userData = await getUser(response?.data?.user_id);
          let studentData;
          if (response?.data?.parent?.student_id) {
            const res = await getStudentData(response?.data?.parent?.student_id);
            if (res?.data?.student_id) {
              studentData = await getUser(res?.data?.user_id);
            }
          }
          const dcpScore = await getDcpIndexScore(response?.data?.student_id || response?.data?.parent?.student_id);
          dispatch(signUpSuccess({
            user: {
              ...response.data,
              indexScore: dcpScore?.data?.dcpIndexScore,
              student_current_grade: dcpScore?.data?.student_current_grade,
              avatar: userData.data.avatar,
              login_type: userData?.data?.login_type,
              student_id: response?.data?.student_id || response?.data?.parent?.student_id,
              user_id: studentData?.data?.user_id || response?.data?.user_id,
              parent_user_id: studentData?.data?.user_id ? response?.data?.user_id : '',
              parent_email: studentData?.data?.user_id ? studentData?.data?.email : ''
            }
          }));
          dispatch(setLoading({
            loading: false
          }));
        }
      }
    } catch (err) {
      const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
      dispatch(setLoading({
        loading: false
      }));
      showNotification(errorMessage, 'error');
    }
  }

  useEffect(() => {
    if (localStorage.getItem('token')) {
      dispatch(setLoading({
        loading: true
      }));
      getUserData();
    }
  }, [localStorage.getItem('token'), location.pathname]);

  if (!localStorage.getItem('token')) {
    return <Navigate to="/login" replace />;
  }

  return <>
    {loading && (
      <LoadingSpinner />
    )}
    <Header />
    <Box pl={isMobile ? 1 : location.pathname === '/services' ? 0 : 4} pr={isMobile ? 1 : location.pathname === '/services' ? 0 : 4}
      pt={{
        md: 13, // small laptop
        lg: 13, // desktop 15"
        xl: 17  // large desktop 17"
      }}>
      {children}
    </Box>
  </>;
};

export default PrivateRoute;